import { DesignSystemPage } from "@components/dev/DesignSystemPage";
import { SimulationsDashboard } from "@components/simulations/SimulationsDashboard";
import { Route } from "react-router-dom";

export const useRenderDebugRoutes = () => (
    <>
        <Route path="/simulations" element={<SimulationsDashboard />} />

        <Route path="/design-system/*" element={<DesignSystemPage />} />
    </>
);
